import { HTTP_CP_Company } from '@api-new/companyservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';

export const getCompanyById = createAction('[COMPANY] Get Company By ID', props<{ id: string }>());

export const getCompanyByIdSuccess = createAction('[COMPANY] Get Company By ID Success', props<{ company: HTTP_CP_Company }>());

export const getCompanyByIdFailure = createAction('[COMPANY] Get Company By ID Failure', props<{ error: ErrorModel }>());
